import styles from './styles.module.scss';

import { useNavigate } from 'react-router-dom';
import { Stamp } from '../Stamp';

interface ModuleOptionProps extends React.HTMLAttributes<HTMLDivElement> {
    icon: any;
    alt: string;
    moduleLink: string;
    isCompleted?: boolean;
}

export const ModuleOption = ({
    icon,
    alt,
    moduleLink,
    isCompleted,
    ...rest
}: ModuleOptionProps) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(moduleLink);
    };

    return (
        <div {...rest}>
            <div className={styles.wrapper}>
                <img
                    src={icon}
                    className={styles.icon}
                    draggable={false}
                    alt={alt}
                    title={alt}
                    onClick={handleClick}
                    style={{ pointerEvents: 'all' }}
                />
                {isCompleted && (
                    <Stamp icon='trophy' className={styles.stamp} title='Curso concluído' />
                )}
            </div>
        </div>
    );
};
